<div class="page-title" [ngClass]="'page-title-' + pathName">
  <content-title [title]="'Mailings.Templates.' + pathName | translate" />
</div>

<ng-container *ngIf="rows?.length; else emptyList">
  <div class="scroll-wrapper">
    <app-mailing-template-item
      *ngFor="let row of rows"
      [project]="mailingService.project"
      [id]="row.id"
      [title]="row.name"
      [subject]="row.title"
      [content]="row.content"
      [email]="email"
    />
  </div>
</ng-container>

<ng-template #emptyList>
  <div class="mailing-page-empty-state">
    <h3 class="mailing-page-empty-state__title">
      {{ 'Mailings.Templates.emptyTitle' | translate }}
    </h3>

    <img
      class="mailing-page-empty-state__image"
      src="./assets/img/empty-projects.svg"
      [alt]="'Mailings.Templates.emptyTitle' | translate"
      draggable="false"
    />

    <p class="mailing-page-empty-state__subtitle">
      {{ 'Mailings.Templates.emptySubtitle' | translate }}
    </p>
  </div>
</ng-template>
